import { render, staticRenderFns } from "./NavigationLayout.vue?vue&type=template&id=05cdc8f5&scoped=true"
import script from "./NavigationLayout.vue?vue&type=script&lang=js"
export * from "./NavigationLayout.vue?vue&type=script&lang=js"
import style0 from "./NavigationLayout.vue?vue&type=style&index=0&id=05cdc8f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cdc8f5",
  null
  
)

export default component.exports